import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['userIsEmployee', 'user'])
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/resources/computed.js